import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js';
import AddChargeAmountModalUI from './AddChargeAmountModalUI.js';
import CacheKeys from '../../../cache/CacheKeys.js';
import CacheManager from '../../../cache/CacheManager.js';

class AddChargeAmountModalSF extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();

    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      invoiceNumber: '',
      invoiceNumberError: null,

      invoiceDateISO: '',
      invoiceDateISOError: null,

      chargeAmountF: '',
      chargeAmountFError: null,

      dueDateISO: '',
      dueDateISOError: null,

      remarks: '',
      remarksError: null,
    };
  }

  render() {
    return (
      <AddChargeAmountModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        addMode={this.props.addMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.handleSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        invoiceNumber={this.state.invoiceNumber}
        onInvoiceNumberChange={(event) => { this.setState({ invoiceNumber: event.target.value }) }}
        invoiceNumberError={this.state.invoiceNumberError}
        setInvoiceNumberError={(error) => { this.setState({ invoiceNumberError: error }) }}
        //
        invoiceDateISO={this.state.invoiceDateISO}
        onInvoiceDateISOChange={(selectedDateISO) => { this.setState({ invoiceDateISO: selectedDateISO }) }}
        invoiceDateISOError={this.state.invoiceDateISOError}
        setInvoiceDateISOError={(error) => { this.setState({ invoiceDateISOError: error }) }}
        //
        chargeAmountF={this.state.chargeAmountF}
        onChargeAmountFChange={(event) => { this.setState({ chargeAmountF: event.target.value }) }}
        chargeAmountFError={this.state.chargeAmountFError}
        setChargeAmountFError={(error) => { this.setState({ chargeAmountFError: error }) }}
        //
        remarks={this.state.remarks}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        //
        dueDateISO={this.state.dueDateISO}
        onDueDateISOChange={(selectedDateISO) => { this.setState({ dueDateISO: selectedDateISO }) }}
        dueDateISOError={this.state.dueDateISOError}
        setDueDateISOError={(error) => { this.setState({ dueDateISOError: error }) }}
        // file upload
        // file input
        fileInput={this.fileInput}
        multiple={this.props.multiple}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context;
    Modal.setAppElement('body');
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log(`Selected file - ${this.fileInput.current.files[0].name}`)

    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    for (let file of this.fileInput.current.files) {
      this.getFileUploadSignedUrl(file)
    }
  }

  getFileUploadSignedUrl(file) {
    let context = this.props.context
    let getResource = `${RestApiUtils.getServerUrl(context)}${this.props.signedUrlApi}` +
      `?fileName=${file.name}&type=${file.type}&size=${file.size}`
    console.log('-> GET', getResource)

    fetch(getResource, {
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json)
        if (json.errorList.length)
          this.setState({ submitted: false, errorList: json.errorList })
        else
          this.uploadFile(json.signedUrl, file)
      })
  }

  uploadFile = (signedUrl, file) => {
    let putResource = signedUrl.signedUrl
    console.log('-> PUT', putResource)
    fetch(putResource, {
      method: 'put',
      body: file,
    })
      .then((response) => {
        console.log('<- PUT', putResource)
        this.props.onUpload(signedUrl.fileId, file.name, file.type, file.size, this.state.invoiceNumber, this.state.invoiceDateISO, this.state.chargeAmountF, this.state.remarks, this.state.dueDateISO)
        setTimeout(() => {
          this.setState({
            successMsg: null, submitted: false
          })
          this.onCancelClick()
        }, 1000)
      })
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onCancelClick = () => {
    this.setState({ submitted: false, successMsg: null, errorList: null, invoiceNumber: '', invoiceDateISO: '', chargeAmountF: '', remarks: '', dueDateISO: '' })
    this.props.onCancelClick()
  }
}

export default AddChargeAmountModalSF;
